<template>
  <container 
    subHeaderTitle="당신에게 <b>일</b>은<br />어떤 의미인가요?" 
    subHeaderText="자신만의 답이 있으신가요? 일과 일터에 대한 바른 시야, 시간의 소중함을 인지할 수 있는 구성원이 모였습니다.<br />반복되는 변화 속 함께 성장하고자 한다면 핀브릿지와 함께해 주세요."
  >
    <section class="ability">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <h1>모두가 안정감을 가지고<br />생활 할 수 있는 환경</h1>
            <v-row>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_1.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">법정 복지 제도</p>
                    <p class="text-content">4대 보험 적용 및 퇴직 연금 </p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_2.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">자유로운 연차 사용</p>
                    <p class="text-content">별도 승인 절차 없이 사용</p>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-8 pt-sm-12">
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_3.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">자율 근무 제도</p>
                    <p class="text-content">업무와 건강에 따라 출퇴근시간을 자유롭게 조절</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_4.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">역량에 따른 보상</p>
                    <p class="text-content">기여와 성과에 대한 파격적인 승진과 스톡옵션</p>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-8 pt-sm-12">
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_5.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">역량 개발 지원</p>
                    <p class="text-content">직무 능력 향상을 위한 도서, 강의, 세미나 등 지원</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_6.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">식대 일체 제공</p>
                    <p class="text-content">중식 지원 및 추가 근무 시 석식 제공</p>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-8 pt-sm-12">
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_7.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">주차비 지원</p>
                    <p class="text-content">주차비용 50% 지원</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_8.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">내일채움공제</p>
                    <p class="text-content">기업과 정부가 공동 적립</p>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-8 pt-sm-12">
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_9.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">건강검진 지원</p>
                    <p class="text-content">본인 건강검진비용 지원</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_10.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">생일 축하 선물</p>
                    <p class="text-content">해당 월 생일 축하 선물 증정</p>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-8 pt-sm-12">
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_11.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">전직원 실손보험 지원</p>
                    <p class="text-content">(단체)실손보험 가입 및 보험료 지원</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column flex-sm-row">
                  <img src="@/assets/new/image/career/culture_icon_12.svg" alt="icon" />
                  <div class="ml-sm-8">
                    <p class="text-title">장기근속자 포상 휴가</p>
                    <p class="text-content">장기근속 휴가 지원금 지급(200만 원)</p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="office">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="pb-0 pb-sm-4">
                <img src="@/assets/new/image/career/office_1.jpg" alt="Finbridge Office" />
              </v-col>
              <v-col cols="12" sm="6" class="pb-0 pb-sm-4">
                <img src="@/assets/new/image/career/office_2.jpg" alt="Finbridge Office" />
              </v-col>
<!--              <v-col cols="12" sm="4" class="pb-0 pb-sm-4">-->
<!--                <img src="@/assets/new/image/career/office_3.jpg" alt="Finbridge Office" />-->
<!--              </v-col>-->
<!--              <v-col cols="12" sm="4" class="pb-0 pb-sm-4">-->
<!--                <img src="@/assets/new/image/career/office_4.jpg" alt="Finbridge Office" />-->
<!--              </v-col>-->
              <v-col cols="12" sm="6" class="pb-0 pb-sm-4">
                <img src="@/assets/new/image/career/office_6.jpg" alt="Finbridge Office" />
              </v-col>
              <v-col cols="12" sm="6" class="pb-0 pb-sm-4">
                <img src="@/assets/new/image/career/office_5.jpg" alt="Finbridge Office" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<style lang="scss">
@import "@/styles/career";
</style>

<script>
import Container from "@/pages/container/index.vue";

export default {
  mixins: [],
  name: "Culture",
  components: {
    Container
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {}
};
</script>
